/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { ccEnum } from '../../CCEnum';
import ComponentBase from '../../ComponentBase';
import Decorators from '../../Decorators';
import Observable from '../../Observable/Observable';
import { PersistRootNode } from '../Node/PersistRootNode';
import ComponentReference from './ComponentReference';
import IReferenced from './IReferenced';
import { ReferenceGroup } from './ReferenceGroup';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * Abstract component class that allows derrived classes to be
 * used with [[InjectableComponent]] class.
 */
@cc._decorator.ccclass
export default class ReferencedComponent extends ComponentBase implements IReferenced
{
    /** Whether instance of component is injectable. */
    @property({ visible: true })
    protected _isActive: boolean = false;
    public set IsActive(value: boolean)
    {
        if (value === this._isActive) { return; }

        this._isActive = value;
        if (value) { this.AddReference(); }
    }
    public get IsActive(): boolean { return this._isActive; }

    /** [[Observable]] of isActive for adding to injection later. */
    private _isActiveObservable: Observable<boolean> = new Observable<boolean>(this._isActive);

    /** Group This instance belongs to. */
    @property({ type: ccEnum.ReferenceGroup })
    public ReferenceGroup: ReferenceGroup = ReferenceGroup.MainGame;

    /** ID of This instance of component. */
    @property({ visible: true })
    public InstanceId?: string = "";

    /** Flag indicated if this instance has been added to injection map. */
    protected isAdded: boolean = false;

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this._isActiveObservable.Value = this._isActive;
        this._isActiveObservable.OnChanged(this.AddReference);

        this.AddReference();
    }

    /** @hidden */
    protected onDestroy(): void
    {
        if (this._isActiveObservable) { this._isActiveObservable.OffChanged(this.AddReference); }
        super.onDestroy();
    }

    /** Add this component to the [[ComponentReference]] map. */
    @Decorators.BindThis()
    public AddReference = (): void =>
    {
        if (!this._isActive || this.isAdded) { return; }

        const globalComponent: PersistRootNode = this.getComponent(PersistRootNode);

        ComponentReference.AddComponentToMap(this, this.ReferenceGroup,
            this.InstanceId, globalComponent ? true : false);
        this.isAdded = true;
    }
}
